import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type { ApiCompaniesHouseCompany } from "@/types/companies-house"

export const companiesHouseQueries = {
  /** Everything Companies House says about the firm's company, worded by the API. */
  forFirm: (firmId: string) =>
    queryOptions({
      queryKey: apiKey(`/firms/${firmId}/companies-house`),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<ApiCompaniesHouseCompany>>(
          `/firms/${firmId}/companies-house`,
          { signal }
        )

        return data
      },
    }),
}
